import { ref, computed } from 'vue'
import { useToast } from 'vue-toastification'
import PATHS from '@/router/paths'

/**
 * Encapsula a construcao e a copia do link de convite do medico.
 * Usado por CompanyInviteRow.vue (uma instancia por empresa/convite).
 *
 * @param getHash getter reativo do hash do convite (invite?.hash)
 */
export function useInviteLink(getHash: () => string | null | undefined) {
  const toast = useToast()
  const isCopied = ref(false)

  const inviteUrl = computed(() => {
    const hash = getHash()
    if (!hash) return null
    const baseUrl = process.env.VUE_APP_URL ?? window.location.origin
    return `${baseUrl}${PATHS.MANAGE_DOCTOR_INVITE}?token=${hash}`
  })

  const copy = () => {
    if (!inviteUrl.value) return
    navigator.clipboard
      .writeText(inviteUrl.value)
      .then(() => {
        isCopied.value = true
        setTimeout(() => {
          isCopied.value = false
        }, 1500)
      })
      .catch(() => {
        toast.error('Não foi possível copiar o link. Tente novamente.')
      })
  }

  return { inviteUrl, isCopied, copy }
}
